import { api } from '@/api';

export interface CheckFileStatusRequest {
  fletchDocumentIds: string[];
}

export interface CheckFileStatusItem {
  status: string;
  validationError: string | null;
}

export interface CheckFileStatusResponse {
  documentStatuses: Record<string, CheckFileStatusItem>;
}

export const fileCheckStatusApi = api.injectEndpoints({
  endpoints: (builder) => ({
    checkFileStatus: builder.query<CheckFileStatusResponse, CheckFileStatusRequest>({
      query: ({ fletchDocumentIds }) => ({
        url: '/document/status',
        method: 'GET',
        params: {
          fletchDocumentIds,
        },
      }),
      // Polling retries on its own schedule, and a 404 never turns into a 200.
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyCheckFileStatusQuery } = fileCheckStatusApi;
